import { create } from "zustand";
import { DefaultActiveElements } from "../optics/components/drawers/settings/features/news/defaults";

const DEFAULT_DATA = {
  config: {
    showTabs: false,
    type: "org-chart",
    variant: "card",
    enrichment: "dynamic",
    columns: 2,
    titleFieldId: "",
    footerFieldId: "",
    pagination: "infinite",
    cardBorderRadius: 3,
    activeElements: DefaultActiveElements,
  },
};

export const useOrgChartStore = create((set, get) => ({
  data: DEFAULT_DATA,
  setData: (value, isUndo = false, isRedo = false) => {
    const currentData = get().data;
    const newData = { ...currentData, ...value };

    set(() => ({
      data: newData,
    }));
  },

  getData: () => get().data,

  updateConfig: ({ value, key }) => {
    const currentData = { ...get().data };

    let newData = {};
    if (key) {
      newData = {
        ...currentData,
        config: {
          ...currentData.config,
          [key]: value,
        },
      };
    } else {
      newData = {
        ...currentData,
        config: {
          ...currentData.config,
          ...value,
        },
      };
    }

    set(() => ({
      data: newData,
    }));
  },

  resetStore: () => {
    set({
      data: {},
      position: 0,
      history: [],
    });
  },
}));
